module.exports = "<div *ngFor=\"let scaleResult of result.scaleResults\">\n  <div class=\"row mb-0 mt-3\" *ngIf=\"!SkipContent\">\n    <app-scale-range-content class=\"col\" [scaleResult]=\"scaleResult\"></app-scale-range-content>\n  </div>\n  <div class=\"row\">\n    <app-scale-questions-list  class=\"col-12 d-report-print-page\" [Questions]=\"result.assessment.getQuestionsForScale(scaleResult.scale)\"></app-scale-questions-list>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/client-assessment-result-view/client-assessment-result-view.component.html
// module id = ./src/app/reports/client-assessment-result-view/client-assessment-result-view.component.html
// module chunks = main